/**
 * Hand a document to the printer.
 *
 * A hidden iframe rather than `window.open`: a popup gets blocked by the
 * browser or by the kitchen's kiosk settings, and a print that silently does
 * not happen is exactly the bug T-1003 is fixing. The frame is removed once the
 * dialog closes, so repeated printing does not stack up frames.
 */
export function openPrintWindow(html: string, doc: Document = document): void {
  const frame = doc.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  frame.style.position = "fixed";
  frame.style.right = "0";
  frame.style.bottom = "0";
  frame.style.width = "0";
  frame.style.height = "0";
  frame.style.border = "0";

  frame.onload = () => {
    const win = frame.contentWindow;
    if (!win) return;
    win.focus();
    win.print();
    // Safari fires `afterprint` late or not at all, so the frame is cleaned up
    // on a timer as well; removing it twice is harmless.
    win.addEventListener?.("afterprint", () => frame.remove());
    setTimeout(() => frame.remove(), 60_000);
  };

  doc.body.appendChild(frame);
  frame.srcdoc = html;
}
